export default "__VITE_ASSET__dsCvak49__"